import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Users, FileText, DollarSign, ArrowLeft } from "lucide-react";

const AdminDashboard = () => {
  const navigate = useNavigate();

  const adminSections = [
    {
      title: "Members",
      description: "View all members, their tiers, and total advanced amounts",
      icon: Users,
      path: "/admin/members",
      color: "bg-blue-500"
    },
    {
      title: "Help Requests",
      description: "Review, approve, or decline member help requests",
      icon: FileText,
      path: "/admin/requests",
      color: "bg-purple-500"
    },
    {
      title: "Covers & Repayments",
      description: "Track approved covers and manage repayments",
      icon: DollarSign,
      path: "/admin/covers",
      color: "bg-emerald-500"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-secondary/10 to-background py-12 px-6">
      <div className="container mx-auto max-w-6xl">
        <Button 
          data-testid="back-to-dashboard-btn"
          variant="ghost" 
          onClick={() => navigate('/dashboard')}
          className="mb-6 rounded-full"
        >
          <ArrowLeft className="mr-2 h-4 w-4" /> Back to Dashboard
        </Button>

        <div className="bg-card rounded-3xl shadow-soft p-8 md:p-12">
          <h1 className="text-4xl font-heading font-bold mb-2" data-testid="admin-dashboard-title">
            Admin Dashboard
          </h1>
          <p className="text-muted-foreground mb-12">
            Manage members, review requests, and track repayments
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {adminSections.map((section) => (
              <button
                key={section.path}
                data-testid={`admin-${section.title.toLowerCase().replace(/\s+/g, '-')}-btn`}
                onClick={() => navigate(section.path)}
                className="text-left p-8 rounded-2xl border-2 border-border hover:border-primary transition-all bg-card hover:shadow-hover group"
              >
                <div className={`${section.color} w-14 h-14 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                  <section.icon className="h-7 w-7 text-white" />
                </div>
                <h3 className="text-2xl font-heading font-bold mb-2">{section.title}</h3>
                <p className="text-muted-foreground">{section.description}</p>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
